import React, { useEffect, useState } from "react";
import { Voltar } from "../../components/Voltar";
import BetterTextField from "../../components/BetterTextField";
import BetterButton from "../../components/BetterButton";
import PinInput from 'react-pin-input'
import ValidarSenha from "../../components/auth/ValidarSenha";
import { forgotPassword, resetPassword, validarCodigo } from "../../crud/auth.crud";
import { swalCustom, testeDeEmail } from "../../utils/Utils";
import { useRef } from "react";
import { CircularProgress } from "@material-ui/core";

export default function RecuperarSenha(props) {
	const [step, setStep] = useState(1);
	const [email, setEmail] = useState('');
	const [codigo, setCodigo] = useState('');
	const [senha, setSenha] = useState('');
	const [code, setCode] = useState('');
	const [segundos, setSegundos] = useState(0);
	const timerRef = useRef(null);
	const { setLoading, loading } = props;

	useEffect(() => () => clearInterval(timerRef.current), []);

	useEffect(() => {
		if (senha) handle();
	}, [senha])

	const handle = () => {
		if (step === 1) {
			if (!email) return swalCustom("Ops!", "Adicione seu e-mail antes de continuar", "error");

			if (!testeDeEmail(email)) return swalCustom("Ops!", "Adicione um e-mail válido", 'error')

			setLoading(true);

			forgotPassword({ email }).then(() => {
				setStep(2);
				setLoading(false);
			});
			return;
		}

		if (step === 2) {
			setLoading(true);

			validarCodigo({ email, code: codigo }).then((res) => {
				setStep(3);

				setCode(res.data.code);
			}).catch((err) => {
				swalCustom("Ops!", err?.response?.data?.errors ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error")
			}).finally(() => {
				setLoading(false);
			});
			return;
		}

		if (step === 3) {
			setLoading(true);

			resetPassword({ email, password: senha, code }).then((res) => {
				if (res.status === 200) {
					swalCustom("Sucesso!", 'Senha alterada com sucesso.', 'success').then(() => {
						props.setPage('LOGIN');
					});
				}

			}).catch((err) => {
				swalCustom("Ops!", err?.response?.data?.errors ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error")
			}).finally(() => {
				setLoading(false);
			});

			return;
		}
	}

	const iniciarTimer = () => {
		setSegundos(10);

		timerRef.current = setInterval(() => {
			setSegundos((prev) => {
				if (prev <= 1) {
					clearInterval(timerRef.current);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);
	};

	const stepBack = () => {
		setCodigo('');
		setStep(step - 1);
		return;
	}

	const reenviar = () => {
		iniciarTimer();

		forgotPassword({ email }).then(() => {
			//TODO - adicionar limitador
		});
	}

	const handleSubmitSenha = (senha) => {
		setSenha(senha);
	}

	return (<>
		<div className="recuperar-senha">
			{step === 1 && (
				<div className="flex-column">
					<div>
						<p className="titulo header-voltar">
							<Voltar onClick={() => props.setPage('LOGIN')} /> Recuperar senha
						</p>

						<p className="subtitulo">Informe seu e-mail abaixo. Se existir no sistema, um código será enviado para você prosseguir.</p>
					</div>

					<BetterTextField label={'E-mail'} required type="email" placeholder="E-mail" name="email" onChange={(e) => setEmail(e.target.value)} value={email} />

					<BetterButton loading={loading} className="btn btn-primary" style={{ width: '100%' }} onClick={handle}>Enviar código</BetterButton>
				</div>
			)}

			{step === 2 && (
				<div className="flex-column">
					<div>
						<p className="titulo header-voltar">
							<Voltar onClick={stepBack} /> Código de verificação
						</p>

						<p className="subtitulo">Insira abaixo o código de confirmação enviado no seu e-mail.</p>
					</div>

					<div className="pin-input">
						<PinInput
							key={'pinInput'}
							length={6}
							focus
							type="numeric"
							inputFocusStyle={{ borderColor: '#8B2EE8' }}
							onComplete={(value) => setCodigo(value)}
							onChange={(value) => setCodigo(value)}
							placeholder={'0'}
						/>

						{segundos > 0 ? (
							<p className="texto">
								<CircularProgress variant="determinate" value={(segundos / 10) * 100} size={'15px'} /> Aguarde
							</p>
						) : (
							<p className="texto">Não recebeu o código?
								<span onClick={reenviar}> Reenviar</span>
							</p>
						)}

					</div>

					<BetterButton disabled={codigo.length < 6} loading={loading} className="btn btn-primary" style={{ width: '100%' }} onClick={handle}>Continuar</BetterButton>
				</div>
			)}

			{step === 3 && (
				<div className="recuperar-senha">
					<div className="voltar">
						<p className="titulo header-voltar">
							<Voltar onClick={stepBack} /> Alterar senha
						</p>

						<p className="subtitulo">Informe sua nova senha de acesso abaixo.</p>

						<ValidarSenha handle={handleSubmitSenha} loading={loading} />
					</div>
				</div>
			)}

		</div>
	</>)
}